export const STATUS =Object.freeze( {
	PROCESS: 1,
	VALIDATE_RH: 2,
	VALIDATE_BOSS: 3,
	AWAITED_DOCUMENT: 4,
	PASS_PAY: 5,
	PAY: 6,
	PAY_BACK: 7,
	FINISHED: 8,
	REJECT: 9,
})